export type TouchInputState = {
  moveX: number;
  moveY: number;
  fire: boolean;
  jump: boolean;
  grenade: boolean;
  pack: boolean;
  boost: boolean;
};

const DEFAULT_TOUCH_INPUT_STATE: TouchInputState = {
  moveX: 0,
  moveY: 0,
  fire: false,
  jump: false,
  grenade: false,
  pack: false,
  boost: false,
};

let touchInputState: TouchInputState = { ...DEFAULT_TOUCH_INPUT_STATE };

export function getTouchInputState(): TouchInputState {
  return { ...touchInputState };
}

export function setTouchInputState(update: Partial<TouchInputState>): TouchInputState {
  touchInputState = {
    ...touchInputState,
    ...update,
    moveX: clampAxis(update.moveX ?? touchInputState.moveX),
    moveY: clampAxis(update.moveY ?? touchInputState.moveY),
  };
  return getTouchInputState();
}

export function resetTouchInputState(): TouchInputState {
  touchInputState = { ...DEFAULT_TOUCH_INPUT_STATE };
  return getTouchInputState();
}

function clampAxis(value: number) {
  if (!Number.isFinite(value)) {
    return 0;
  }
  return Math.min(1, Math.max(-1, value));
}
